/* Copyright 2013 - 2024 Waiterio LLC */
import ENVIRONMENT from './ENVIRONMENT.js'
import STAGING from './STAGING.js'

export default ENVIRONMENT === STAGING
